import { render, staticRenderFns } from "./SubmissionListView.vue?vue&type=template&id=58090951&scoped=true&"
import script from "./SubmissionListView.vue?vue&type=script&lang=js&"
export * from "./SubmissionListView.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionListView.vue?vue&type=style&index=0&id=58090951&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58090951",
  null
  
)

export default component.exports